import React, { useState } from "react";
import { Link } from "react-router-dom";

const CategoryNav = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const categories = [
    { id: 1, name: "Ev Temizliği", path: "/ev-temizligi" },
    { id: 2, name: "Ofis Temizliği", path: "/ofis-temizligi" },
    { id: 3, name: "Halı Yıkama", path: "/hali-yikama" },
    { id: 4, name: "Koltuk Yıkama", path: "/koltuk-yikama" },
    {
      id: 5,
      name: "Kuru Temizleme",
      path: "/kuru-temizleme",
      subCategories: [
        {
          id: "a",
          name: "A Ürünleri Kuru Temizleme",
          path: "/kuru-temizleme/a-urunleri",
        },
        {
          id: "b",
          name: "B Tip Kuru Temizleme",
          path: "/kuru-temizleme/b-tip",
        },
        {
          id: "c",
          name: "C Tarzında Kuru Temizleme",
          path: "/kuru-temizleme/c-tarzinda",
        },
        {
          id: "d",
          name: "D Segmenti Kuru Temizleme",
          path: "/kuru-temizleme/d-segmenti",
        },
      ],
    },
    { id: 6, name: "Kutu Temizleme", path: "/kutu-temizleme" },
    { id: 7, name: "Kutu Temizleme", path: "/kutu-temizleme-2" },
    { id: 8, name: "Kutu Temizleme", path: "/kutu-temizleme-3" },
    { id: 9, name: "Araç Yıkama", path: "/arac-yikama" },
    { id: 10, name: "Boş Ev Temizliği", path: "/bos-ev-temizligi" },
    {
      id: 11,
      name: "Taşınma Sonrası Temizlik",
      path: "/tasinma-sonrasi-temizlik",
    },
  ];

  return (
    <nav className="bg-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-16 overflow-x-auto whitespace-nowrap hide-scrollbar">
          {categories.map((category) => (
            <div key={category.id} className="relative h-full flex-shrink-0">
              <div
                className="text-gray-600 hover:text-indigo-600 text-sm font-medium transition-colors px-4 h-full flex items-center cursor-pointer"
                onMouseEnter={() =>
                  category.subCategories && setActiveDropdown(category.id)
                }
                onMouseLeave={() => setActiveDropdown(null)}
              >
                {category.name}
                {category.subCategories && (
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                )}
              </div>
              {category.subCategories && activeDropdown === category.id && (
                <div
                  className="absolute left-0 w-56 bg-white rounded-md shadow-lg py-1 mt-0 z-50"
                  onMouseEnter={() => setActiveDropdown(category.id)}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  {category.subCategories.map((subCategory) => (
                    <Link
                      key={subCategory.id}
                      to={subCategory.path}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-[#4F46E5]"
                    >
                      {subCategory.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default CategoryNav;
